import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { FiSettings, FiMonitor, FiUsers } from "react-icons/fi";
import { NavLink, NavLinkProps } from 'react-router-dom';
import { AiOutlineHome, AiOutlinePlus, AiOutlineUnorderedList } from "react-icons/ai";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { VscInfo } from "react-icons/vsc";
import { CgUserList } from "react-icons/cg";

import { Botao } from 'view/component/Botao/Botao';
import { H2 } from 'view/component/Tipografia/Texto';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { DEVELOPMENT } from 'util/Dev';
import { useAutorizacao } from 'view/component/Autorizacao/useAutorizacao';

import { SolicitacoesAction } from 'store/Solicitacoes/Solicitacoes.action';
import { useUsuarioLogado } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';
import { ReactUtils } from 'util/ReactUtils';

import "./menu.scss";


export interface MenuContextProps {
  compacto: boolean,
  toggle: () => void
}

export const MenuContext = React.createContext<MenuContextProps>({
  compacto: false,
  toggle: () => {}
});

export const MenuProvider: React.FunctionComponent = (props) => {
  const [state, setState] = useState(false);

  const providerValue = {
    compacto: state,
    toggle: () => setState(!state)
  }

  return <MenuContext.Provider value={providerValue}>{props.children}</MenuContext.Provider>
}

export const Menu: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const usuarioLogado = useUsuarioLogado();

  const autorizacao = useAutorizacao();
  const reino = autorizacao.membroUnidade?.unidade.reino;
  const papeis = autorizacao.papeis;

  const iniciarMinhasSolicitacoes = () => dispatch(SolicitacoesAction.lista.iniciarMinhasSolicitacoes(usuarioLogado.idInstitucional));
  const iniciarSolicitacoesDoReino = () => dispatch(SolicitacoesAction.lista.iniciarUnidadesDoReino(autorizacao.membroUnidade?.unidade.id));


  const itensMenuAdmin = papeis.Nivel1
    ? <ItemMenu navlink={{to:"/admin/permissoes"}} icone={FiSettings}>Administração</ItemMenu> 
    : <></>

  return (
    <MenuContainer id="menu">
      <H2 srOnly>Teste de formulário</H2>
      <ul>
        <ItemMenuSwapComprimido />

        {DEVELOPMENT && <ItemMenu navlink={{exact: true, to:"/"}} icone={AiOutlineHome}>Página inicial</ItemMenu>}
        {papeis.Nivel1 && <ItemMenu navlink={{to:"/solicitacoes/new"}} icone={AiOutlinePlus}>Nova solicitação</ItemMenu>}
        <ItemMenu navlink={{exact: true, to:"/solicitacoes"}} icone={AiOutlineUnorderedList} onClick={iniciarMinhasSolicitacoes}>Minhas solicitações</ItemMenu>
        {papeis.Nivel1 && <ItemMenu navlink={{exact: true, to:"/solicitacoes/reino"}} icone={CgUserList} onClick={iniciarSolicitacoesDoReino}>Solicitações - {reino?.sigla}</ItemMenu>}
        {papeis.Administrador && <ItemMenu navlink={{exact: true, to:"/admin/classificacoes"}} icone={FiSettings}>Classificações</ItemMenu>}
        {papeis.Administrador && <ItemMenu navlink={{exact: true, to:"/admin/permissoes"}} icone={FiUsers}>Usuários</ItemMenu>}
        {DEVELOPMENT && <ItemMenu navlink={{exact: true, to:"/sla"}} icone={FiMonitor}>Painel SLA</ItemMenu>}
        <ItemMenu navlink={{exact: true, to:"/sobre"}} icone={VscInfo}>Sobre</ItemMenu>

        {DEVELOPMENT && <ItemMenu navlink={{exact: true, to:"/testeFormulario"}} icone={VscInfo}>Teste de formulário</ItemMenu>}
        

        {/* {DEVELOPMENT && itensMenuAdmin} */}
      </ul>
    </MenuContainer>
  )
}

const MenuContainer = styled.nav`
  background: var(--menu-background);
  padding-left: ${Spacing.unit}px;
  padding-right: ${Spacing.unit}px;

  ul {
    margin: 0px;
    padding: 0px;
  }
`;

interface ItemMenuProps {
  navlink: NavLinkProps<any>,
  icone: any,
  onClick?: () => void,
}

export const ItemMenu: React.FunctionComponent<ItemMenuProps> = (props) => {
  const context = useContext(MenuContext);

  const title = context.compacto ? ReactUtils.asText(props.children) : undefined;
  
  const iconeClassName = context.compacto ? 'compacto' : '';
  const titleClassName = context.compacto ? 'sr-only' : '';

  return <ItemMenuContainer className="item-menu">
    <ItemMenuBotao as={NavLink} {...props.navlink} title={title} onClick={props.onClick} >
      <ItemMenuIcone as={props.icone} className={iconeClassName} aria-hidden="true" />
      <ItemMenuText className={titleClassName}>{props.children}</ItemMenuText>
    </ItemMenuBotao>
  </ItemMenuContainer>;
}

const ItemMenuContainer = styled.li`
  display: block;
  color: red;
`;

const ItemMenuBotao = styled.a`
  display: block;

  text-decoration: none;
  color: var(--color-text-dark);

  padding: ${Spacing.unit}px ${Spacing.unit + 2}px;
  border-radius: 3px;

  &[aria-current="page"],
  &:hover,
  &:focus {
    text-decoration: none;
    color: var(--color-text-dark);
    background-color: rgba(0, 0, 0, .15);
  }
`;

const ItemMenuIcone = styled.svg`
  text-align: center;
  color: var(--color-text-dark);

  width: ${Spacing.unit*3}px;
  height: ${Spacing.unit*3}px;
  
  vertical-align: middle;

  &.compacto {
    margin-left: ${Spacing.unit}px;
  }
`;

const ItemMenuText = styled.span`
  margin-left: ${Spacing.unit*2}px;
  vertical-align: middle;
`;

export const ItemMenuSwapComprimido: React.FunctionComponent = (props) => {
  const context = useContext(MenuContext);

  const clickHold = () => context.toggle()

  if (context.compacto)
    return <li aria-hidden={true} id="toggle-compacto" className="item-menu"><Botao title="Detalhar menu" onClick={clickHold}><MdKeyboardArrowRight aria-hidden={true} /></Botao></li>

  return <li aria-hidden={true} id="toggle-compacto" className="item-menu toggle"><Botao title="Compactar menu" onClick={clickHold}><MdKeyboardArrowLeft aria-hidden={true} /></Botao></li>
}